import { motion } from 'framer-motion';
import React from 'react';
import screen01 from './img/sec06-screen01.png';
import screen02 from './img/sec06-screen02.png';
import medal from '../img/sec06-medal-dynamic-gradient.png';
import megaphone from '../img/sec06-megaphone-dynamic-gradient.png';
import puzzle from '../img/sec06-puzzle-dynamic-gradient.png';
import chat from '../img/sec06-chat-bubble-dynamic-gradient.png';
import partyPopper from '../img/sec06-partypopper.png';
import { ChurchschoolPrices } from '../../homeschool/ChurchschoolPriceContext';

const HFHJSection6 = () => {
  return (
    <>
      <div className="flex justify-center bg-[#FE7020] p-3 pt-10 md:p-12 md:pt-20">
        <div className="flex w-full flex-col gap-8 md:gap-12">
          {/* 타이틀 */}
          <section>
            <div className="text-center font-['Pretendard'] text-3xl font-light text-white md:text-4xl">
              <div>정답은,</div>
              <div className="text-2xl font-extrabold text-[#FFDA19]">
                Hello, Father! Hello, Jesus!
              </div>
            </div>
          </section>

          {/* 흰색 박스 */}
          <div className="rounded-2xl bg-white p-5 md:p-10">
            <div className="m-auto max-w-[520px]">
              {/* 영역 1 */}
              <section className="flex flex-col items-center justify-center gap-5">
                <div className="text-center font-['Pretendard'] text-lg font-medium md:text-2xl">
                  아이들에게{' '}
                  <span className="font-semibold text-[#FE7020]">
                    복음과 영어는 꼭 필요
                  </span>
                  하니까!
                </div>
                <div className="flex items-center justify-center gap-2 font-['Pretendard'] text-base font-normal md:text-lg">
                  <div className="rounded-md border border-[#FE7020] p-2 py-1 font-medium">
                    복음
                  </div>
                  +
                  <div className="rounded-md border border-[#FE7020] p-2 py-1 font-medium">
                    영어
                  </div>
                  =
                  <span className="text-lg font-bold text-[#FE7020] md:text-xl">
                    글로벌 크리스천 리더
                  </span>
                </div>
                <div className="text-center text-sm md:text-lg">
                  교회 부흥의 핵심 key는 다음 세대 아이들의 복음화! <br />
                  글로벌 크리스천 리더가 되기 위해 꼭 필요한 영어까지 <br />
                  유치부 아이들에게 꼭 필요한 것들로만 구성된 <br />
                  <span className="font-bold text-[#FE7020]">
                    Hello, Father! Hello, Jesus!
                  </span>
                </div>
              </section>

              {/* 구분선 */}
              <div className="my-5 border-t border-dashed border-[#0000001A] md:my-10"></div>

              {/* 영역 2 */}
              <section className="flex flex-col gap-3">
                <div className="text-center font-['Pretendard'] text-lg font-medium md:text-2xl">
                  아이들은{' '}
                  <span className="font-semibold text-[#FE7020]">
                    재미있어야 하니까!
                  </span>
                </div>

                <div className="grid grid-cols-2">
                  <div className="p-2 md:p-5">
                    <img src={screen01} className="m-auto w-fit p-2" />
                  </div>
                  <div className="my-auto p-1 text-left font-['Pretendard'] text-xs font-normal sm:text-lg md:p-5">
                    다양한 시청각 자료를 통해
                    <br />
                    아이들의 학습 흥미를 유발
                  </div>
                  <div className="p-2 md:p-5">
                    <img src={screen02} className="m-auto w-fit p-2" />
                  </div>
                  <div className="my-auto p-1 text-left font-['Pretendard'] text-[11px] font-normal sm:text-lg md:p-5">
                    성경 애니메이션으로
                    <br />
                    아이들의 흥미 유발
                  </div>
                </div>
              </section>

              {/* 구분선 */}
              <div className="my-5 border-t border-dashed border-[#0000001A] md:my-10"></div>

              {/* 영역 3 */}
              <section className="flex flex-col gap-5">
                <div className="text-center font-['Pretendard'] text-lg font-medium md:text-2xl">
                  영어와 성경,{' '}
                  <span className="font-semibold text-[#FE7020]">
                    확실하게 배울 수 있으니까!
                  </span>
                </div>

                <div className="flex flex-col gap-7">
                  <motion.div
                    className="flex items-center justify-center gap-3 pr-0 sm:pr-12"
                    initial={{ y: -20, opacity: 0 }}
                    whileInView={{ y: 0, opacity: 1 }}
                    transition={{ type: 'spring', duration: 1 }}
                  >
                    <img
                      src={medal}
                      className="aspect-square w-24 object-contain"
                    />
                    <div className="w-full rounded-2xl bg-gray-200 p-4 text-sm shadow-md md:text-base">
                      잠재의식 학습법은 유치부 아이들이 퍼즐을 맞추며 자연스럽게
                      영어문장을 잠재의식에 새길 수 있게 하는 특허받은
                      교수법입니다.
                    </div>
                  </motion.div>

                  <motion.div
                    className="flex items-center justify-center gap-3 pl-0 sm:pl-12"
                    initial={{ y: -20, opacity: 0 }}
                    whileInView={{ y: 0, opacity: 1 }}
                    transition={{ type: 'spring', duration: 1 }}
                  >
                    <div className="w-full rounded-2xl bg-gray-200 p-4 text-sm shadow-md md:text-base">
                      배운 내용을 직접 신체로 표현해보며 영어 단어의 뜻과 문장을
                      자연스럽게 습득할 수 있습니다.
                    </div>
                    <img
                      src={megaphone}
                      className="aspect-square w-24 object-contain"
                    />
                  </motion.div>

                  <motion.div
                    className="flex items-center justify-center gap-3 pr-0 sm:pr-12"
                    initial={{ y: -20, opacity: 0 }}
                    whileInView={{ y: 0, opacity: 1 }}
                    transition={{ type: 'spring', duration: 1 }}
                  >
                    <img
                      src={puzzle}
                      className="aspect-square w-24 object-contain"
                    />
                    <div className="w-full rounded-2xl bg-gray-200 p-4 text-sm shadow-md md:text-base">
                      스토리가 끝날 때마다 연극을 통해 흥미를 유발하며 배운
                      내용을 장기 기억으로 안착시킬 수 있게 합니다.
                    </div>
                  </motion.div>

                  <motion.div
                    className="flex items-center justify-center gap-3 pl-0 sm:pl-12"
                    initial={{ y: -20, opacity: 0 }}
                    whileInView={{ y: 0, opacity: 1 }}
                    transition={{ type: 'spring', duration: 1 }}
                  >
                    <div className="w-full rounded-2xl bg-gray-200 p-4 text-sm shadow-md md:text-base">
                      유치부 아이들도 쉽게 할 수 있는 그리기, 오리기 등의 다양한
                      활동을 통해 협응력이 발달됩니다.
                    </div>
                    <img
                      src={chat}
                      className="aspect-square w-24 object-contain"
                    />
                  </motion.div>
                </div>
              </section>

              {/* 구분선 */}
              <div className="my-5 border-t border-dashed border-[#0000001A] md:my-10"></div>

              {/* 영역 4 */}
              <section className="m-auto flex items-center justify-center gap-2">
                <img src={partyPopper} className="w-12 md:w-20" />
                <div className="text-center font-['Pretendard'] text-lg font-medium md:text-2xl">
                  영어로 복음을 배우고 외치며
                  <div className="font-semibold text-[#FE7020]">
                    성령 충만! 영어 능통!
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HFHJSection6;
